/**
 * @file WebSocket Broadcast Metrics Handler
 * @description Handles the recording of OpenTelemetry metrics for WebSocket broadcast messages, including the size of the broadcast data.
 */

import { buildWsBroadcastMetricAttributes } from './wsMetricAttributes';
import { wsBroadcastSize } from '../metrics';

/**
 * Records OpenTelemetry metrics for a WebSocket broadcast message.
 *
 * @param {string} name - The name of the WebSocket broadcast event.
 * @param {number} dataSize - The size of the data in bytes
 */
export const otlHandleWsBroadcastMetrics = (name, dataSize) => {
    wsBroadcastSize.record(dataSize, buildWsBroadcastMetricAttributes(name));
};
